import { render, staticRenderFns } from "./addcouponLists.vue?vue&type=template&id=56a5a9c6&scoped=true&"
import script from "./addcouponLists.vue?vue&type=script&lang=js&"
export * from "./addcouponLists.vue?vue&type=script&lang=js&"
import style0 from "./addcouponLists.vue?vue&type=style&index=0&id=56a5a9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5a9c6",
  null
  
)

export default component.exports